import moment from "moment/moment";
import htmlToText from "html-to-text";

export default {
    MakePDF(prog){
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        }
        moment.locale('ru');
        let special = ""
        let profile = ""
        if (prog.main_info.speciality_code === '38.05.02' || prog.main_info.speciality_code === '37.05.01'){
            special = "специальности"
            profile = "направленность (профиль) программы специалитета"
        }
        else if (prog.main_info.speciality_code === '38.05.01'){
            special = "специальности"
            profile = "специализация программы специалитета"
        }
        else if (prog.main_info.speciality_code.split('.')[1] !== '05'){
            special = "направления подготовки"
            profile = "направленность (профиль) образовательной программы"
        }
        else{
            special = "специальности"
            profile = "специализация образовательной программы"
        }
        const htmlToText = require('html-to-text');
        function getInitial(fio){
            let initial = ""
            if (fio !== ""){
                fio = fio.replaceAll("  ", " ")
                fio = fio.trim();
                initial += fio.split(' ')[1][0];
                initial +="."
                initial += fio.split(' ')[2][0];
                initial +=". "
                initial += fio.split(' ')[0];
            }
            return initial
        }
        let department = []
        if (prog.main_info.creator.title === null){
            prog.main_info.creator.title = ""
        }
        if (prog.main_info.dep_manager === null){
            prog.main_info.dep_manager = ""
        }

        function buildSoftware() {
            var body = [];
            let n_soft = 0
            if (prog.software.length || prog.resources.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.software.forEach(function(soft) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                prog.resources.forEach(function(res) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        function buildDataBases() {
            var body = [];
            if (prog.data_bases.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.data_bases.forEach(function(db) {
                    body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        let titlePage = {
            info: {
                title: `Лист дополнения к программе практики ${prog.main_info.discipline} ${prog.main_info.speciality_code} `,
                author: 'ЦЦТиТО, АмГУ',
                subject: '',
                keywords: ''
            },
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins:[60,40,60,60],

            header:[],
            footer:[],
            content: [
                {
                    text: `Лист дополнений к программе практики «${prog.main_info.discipline}» для ${special} ${prog.main_info.speciality}, ${profile} - ${prog.main_info.profile}`,
                    style: "twelveBold", alignment: 'center',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [260,90,95],
                        heights: ['auto','auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Утверждено на заседании кафедры', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${prog.main_info.approval_date} г.`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Протокол №', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]},{text:`${prog.main_info.protocol_num}`, style: 'twelveNormal', lineHeight: 0.7, alignment: 'center', border: [false, false, false, true]}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Заведующий кафедрой', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    text: '\t\t УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ ДИСЦИПЛИНЫ', style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t а) литература`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.literature_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags: {
                            'a': { options: {
                                    hideLinkHrefIfSameAsText: true,
                                    noLinkBrackets: true},
                            },
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }),
                    style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t б) программное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildSoftware()
                    }
                },
                {
                    text: `\t\t в) профессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildDataBases()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [170,90,95],
                        heights: [],
                        body:[
                            [{text:`${prog.main_info.creator.position}`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${(prog.main_info.creator.fio.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.creator.fio)}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [50,90,95],
                        heights: [10],
                        body:[
                            [{text:'', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                            [{text:'СОГЛАСОВАНО', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [190,100,120],
                        heights: [5,'auto',5,'auto'],
                        body:[
                            [{text:'', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                            [{text:'Директор научной библиотеки', style: 'twelveNormal', border: [false, false, false, false]},{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `О.В. Петрович`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text:'', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                            [{text:'Центр цифровой трансформации и технического обеспечения', style: 'twelveNormal', border: [false, false, false, false]},{text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `А.А. Тодосейчук`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
            ],
            styles: {
                eightNormal: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false
                },
                tenNormal: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false
                },
                twelveNormal: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    preserveLeadingSpaces: true
                },
                twelveBold: {
                    fontSize: 12,
                    font: 'Times',
                    bold: true,
                    preserveLeadingSpaces: true
                },
            }
        };
        pdfMake.createPdf(titlePage).download(`Лист дополнения к программе практики ${prog.main_info.discipline} ${prog.main_info.speciality_code} ${prog.main_info.year}.pdf`);
    },
}